import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-footer',
    templateUrl: './app-footer.component.html'
})
export class AppFooterComponent {
    public thisYear: number = new Date().getFullYear();
}
